import { useState, useEffect } from 'react';
import { listenToCollection } from '../services/firestore.service';
import { where } from 'firebase/firestore';

export const useForests = () => {
  const [forests, setForests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = listenToCollection(
      'forests',
      [where('status', '==', 'active')],
      (data) => {
        setForests(data);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { forests, loading, error };
};

